const CHILE_TZ = "America/Santiago";

export function todayChile(): string {
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: CHILE_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

export function isFutureDateChile(dateStr: string): boolean {
  return dateStr > todayChile();
}

/**
 * Formatea una fecha (Date o string ISO) a formato YYYY-MM-DD en huso horario oficial de Chile (America/Santiago),
 * evitando el desfase de día causado por .toISOString() en UTC.
 */
export function formatChileDate(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: CHILE_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}

